import { PropsWithChildren, useMemo } from 'react';

import { DirectoryContext, DirectoryContextProps } from './directoryContext';

export const DirectoryProvider = ({
  children,
  record,
  onEnableEdit,
  onDisableEdit,
}: DirectoryContextProps & PropsWithChildren) => {
  const value = useMemo(
    () => ({ record, onEnableEdit, onDisableEdit }),
    [record, onEnableEdit, onDisableEdit]
  );

  return (
    <DirectoryContext.Provider value={value}>
      {children}
    </DirectoryContext.Provider>
  );
};
